import React from 'react'

export default function GoodPoint(props) {
    return (
        <div className="col-md col-6 mb-md-0 mb-4 feature d-flex flex-column justify-content-center align-items-center">
            <img src={props.img} alt="Experience Of Years" />
            <h6 className='mt-1 text-center'>{props.title}</h6>
        </div>
    )
}
